import { Component, OnInit } from '@angular/core';
import { ModalModule } from 'ng2-bootstrap/modal';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit {
  // loader=true;
  constructor() { }

  ngOnInit() {
  }
  // show(){
  //   this.loader=true
  // }
  // hide(){
  //   this.loader=false
  // }
}



// WEBPACK FOOTER //
// ./src/app/share/loader/loader.component.ts